// utils/floorStyles.js
import { useAnimatedStyle } from 'react-native-reanimated';
import { useSafeAreaFrame, useSafeAreaInsets } from 'react-native-safe-area-context';

export const useFloorStyle = (widthMultiplier, translateValue, bottomOffset) => {
  const { height } = useSafeAreaFrame();
  const insets = useSafeAreaInsets();

  const style = useAnimatedStyle(() => {
    return {
      height: 0.182086 * (height - insets.top - insets.bottom),
      width: widthMultiplier * 0.182086 * (height - insets.top - insets.bottom),
      alignSelf: 'center',
      transform: [{ translateX: translateValue.value }],
      position: 'absolute',
      bottom: bottomOffset,
    };
  }, [height, insets, translateValue]);

  return style;
};
